import React, { useState } from 'react';
import Modal from 'react-modal'; // Import Modal from react-modal
import { Link } from 'react-router-dom';

const PreorderComponent = ({ productName, productPrice, releaseDate }) => {
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        quantity: 1
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInfo({
            ...userInfo,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Preorder for ${userInfo.quantity} of ${productName} has been submitted!`);
    };

    return (
        <div className="preorder-component">
            <h2>Preorder {productName}</h2>
            <p><strong>Price:</strong> ${productPrice}</p>
            <p><strong>Release Date:</strong> {releaseDate}</p>

            <form onSubmit={handleSubmit}>
                <label htmlFor="name">Name:</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={userInfo.name}
                    onChange={handleChange}
                    required
                />
                
                <label htmlFor="email">Email:</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={userInfo.email}
                    onChange={handleChange}
                    required
                />

                <label htmlFor="quantity">Quantity:</label>
                <input
                    type="number"
                    id="quantity"
                    name="quantity"
                    min="1"
                    value={userInfo.quantity}
                    onChange={handleChange}
                    required
                />

                <button type="submit">Preorder Now</button>
            </form>
        </div>
    );
};

const PreorderPageWithModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div className="col p-0 position-relative">
            {/* <video
                src={require("../../assets/video/lv_0_20241112164220.mp4")} // Path to your video file
                alt="Drone Video"
                className="w-100"
                style={{ height: "370px", objectFit: "cover" }}
                autoPlay
                loop
                muted
            /> */}
            <div className="hover-text">
                Drones are reshaping industries by enhancing efficiency and unlocking new possibilities. From agriculture and logistics to emergency response and inspections, their versatility is transforming traditional tasks. As technology advances, drones are driving innovation, making them essential tools for modern solutions and expanding the future of what's possible.
            </div>
            {/* Shop Now Button */}
            <div className="shop-now-btn position-absolute">
                <button className="btn btn-primary" onClick={openModal}>
                    Buy Now
                </button>
            </div>

            {/* Modal to show Preorder Component */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Preorder Modal"
                className="modal-content"
                overlayClassName="modal-overlay"
                ariaHideApp={false}
            >
                <div className="modal-header">
                    <button onClick={closeModal} className="close-btn">X</button>
                </div>
                <PreorderComponent 
                    productName="SuperWidget 3000"
                    productPrice="199.99"
                    releaseDate="December 1, 2024"
                />
            </Modal>
        </div>
    );
};

export default PreorderComponent;
